export class AdditionalData {
  Hotel3pId: string;
  GuestStayUuId: string;
  EmailAddress: string;
  PhoneNumber: string;
  PlateNumber: string;
  Signature: string;
}